import detailApiCall from './detail';
import editApiCall from './edit';
import { default as listApiCall } from './list';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  edit: editApiCall,
};

export default ApiCall;
